import type { ITranslation } from '@/interface/ITranslation';
import { LanguageType } from '@/interface/enum';
import { getTranslated } from '@/libraries/helpers/translationHelper';

export interface ImagePath {
    origin: string;
    webp: string;
}

export function getAssetsMapping(glob: Record<string, unknown>) {
    return Object.fromEntries(Object.entries(glob)
        .map(([key, value]) => [
            key.split('/').pop(),
            (value as any).default,
        ]));
}

export function getImage(
    imageGlob: Record<string, unknown>,
    baseName: string,
    fallbackName: string = 'default',
): ImagePath {
    const assetsMapping = getAssetsMapping(imageGlob);

    const primary = assetsMapping[`${baseName}.png`];
    const primaryWebp = assetsMapping[`${baseName}.webp`];

    const fallback = assetsMapping[`${fallbackName}.png`];
    const fallbackWebp = assetsMapping[`${fallbackName}.webp`];

    return {
        origin: primary ?? fallback ?? '',
        webp: primaryWebp ?? fallbackWebp ?? '',
    };
}

export function getSvgImage(
    imageGlob: Record<string, unknown>,
    baseName: string,
    fallbackName: string = 'default',
): string {
    const assetsMapping = getAssetsMapping(imageGlob);

    const primary = assetsMapping[`${baseName}.svg`];
    const fallback = assetsMapping[`${fallbackName}.svg`];

    return primary ?? fallback ?? '';
}

function normalizeTeamName(teamName?: ITranslation[] | string): string {
    if (!teamName) return '';

    return getTranslated(teamName, LanguageType.EN)
        .replaceAll(' ', '')
        .replaceAll('(PEN)', '')
        .replaceAll('(ET)', '');
}

export function getTeamImage(imageGlob: Record<string, unknown>, name?: ITranslation[] | string): ImagePath {
    const normalizedName = normalizeTeamName(name);
    const fallback = 'Unknown';

    if (!normalizedName) {
        return getImage(imageGlob, fallback, fallback);
    }

    return getImage(imageGlob, normalizedName, fallback);
}
